// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"b6e751ad","96":"92e7bf72","99":"df74212b","172":"b2f71386","242":"cdb7685b","392":"fb7504c6","407":"67a8e59b","460":"462cf587","585":"6ef849e9","672":"89cfc9aa","700":"5b97e0d7","871":"b07357df","958":"58dbc963","964":"5eea912c"}[chunkId] + ".chunk.js";
};